import Select from "components/select/Select";
import { useField } from "formik";
import { debounce } from "lodash";
import { useEffect, useMemo, useRef, useState } from "react";
import { useGetIvrDetail, useInfiniteIvr } from "service/query/ivr.query";

const SelectIvr = ({ name }) => {
  const [fieldInput, fieldMeta, fieldHelpers] = useField({
    name,
  });
  const defaultValue = useRef(fieldInput.value);
  const [value, setValue] = useState({
    label: "",
    value: defaultValue.current,
  });

  const { data: ivrDetail } = useGetIvrDetail(defaultValue.current, {
    enabled: !!defaultValue.current,
  });

  const [where, setWhere] = useState(null);
  const { data, isFetching, fetchNextPage } = useInfiniteIvr(where);

  const listOriginData = useMemo(
    () => data?.pages?.flatMap((pageData) => pageData),
    [data?.pages]
  );

  const listOptions = useMemo(
    () =>
      listOriginData?.map((item) => ({
        label: item.name,
        value: item.id,
      })),
    [listOriginData]
  );

  const handleScroll = (e) => {
    const isBottom =
      Math.ceil(e.target.scrollTop) + e.target.clientHeight >=
      e.target.scrollHeight;
    if (isBottom && !isFetching) {
      fetchNextPage();
    }
  };

  const handleSearch = debounce((text) => {
    setWhere(text ? { name: { like: text, options: "i" } } : null);
  }, 300);

  useEffect(() => {
    if (ivrDetail) {
      setValue({
        label: ivrDetail.name,
        value: ivrDetail.id,
      });
    }
  }, [ivrDetail]);

  return (
    <Select
      options={listOptions}
      onScroll={handleScroll}
      loading={isFetching}
      onSearch={handleSearch}
      label="IVR"
      filterOption={false}
      allowClear
      labelInValue
      value={value}
      onChange={(newValue) => {
        setValue(newValue);
        fieldHelpers.setValue(newValue?.value || "");
      }}
      error={fieldMeta.error}
    />
  );
};

export default SelectIvr;
